import { Component } from 'react';
import PropTypes from 'prop-types';


export const ViewportSize = Object.freeze({
  Small: 601,
  Medium: 961,  
  Large: 1281,
  XLarge: 1681,
});

export default class ViewportManager extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.func
    ]).isRequired
  }

  componentWillMount() {
    this.setDeviceWidth();

    window.addEventListener('resize', this.setDeviceWidth, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setDeviceWidth);
  }

  render() {
    const { deviceWidth } = this.state;
    const deviceViewport = getDeviceViewport(deviceWidth);
    return this.props.children({ deviceViewport });
  }

  setDeviceWidth = () => {
    this.setState({ deviceWidth: window.innerWidth });
  }
}

function getDeviceViewport(deviceWidth) {
  let deviceViewport = Object.values(ViewportSize)
    .sort((v1, v2) => v1 > v2)
    .find(viewport => deviceWidth < viewport) || ViewportSize.XLarge;

  return deviceViewport;
}



// WEBPACK FOOTER //
// ./src/utils/ViewportManager.js